export * from './cotacao-analise-component';